module.exports = __webpack_public_path__ + "static/media/instagram.3eee0a5b.png";